<template>
  <hm-content title>
    <div class="flex flex-between">
      <el-button
          type="primary"
          size="small"
          class="add-btn"
          @click="openCreate"
      >创建小程序</el-button
      >
      <el-input
          placeholder="输入版本/名称"
          size="small"
          v-model="filterText"
          @input="filterFunc('uploadedAlipayTempList')"
      ></el-input>
    </div>
    <el-table
        stripe
        ref="roleTable"
        :data="uploadedAlipayTempListResult"
        class="mt20"
        style="width: 100%"
        id="table"
        size="small"
        border
        @selection-change="getChecked"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="编号"
      ></el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="nickName"
          label="来源小程序"
      ></el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="releaseVersion"
          label="版本号"
      ></el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="miniProgramVersion"
          label="提交审核版本号"
      ></el-table-column>
      <!-- <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="center"
          label="模板状态"
      >
        <template slot-scope="scope">
          <span :class="scope.row.pagecode === '-1' ? 'danger' : 'success'">
            {{ scope.row.pagemsg }}
          </span>
        </template>
      </el-table-column> -->
      <el-table-column
          header-align="center"
          align="center"
          prop="status"
          label="审核状态"
      >
        <template slot-scope="scope">
          <span class="success" v-if="scope.row.status === 'INIT'">开发中</span>
          <span class="purple" v-if="scope.row.status === 'AUDITING'">审核中</span>
          <span class="success" v-if="scope.row.status === 'WAIT_RELEASE'">审核通过</span>
          <span class="danger" v-if="scope.row.status === 'AUDIT_REJECT'">审核驳回</span>
          <span class="success" v-if="scope.row.status === 'RELEASE'">已上架</span>
          <span class="gray" v-if="scope.row.status === 'GRAY'">灰度中</span>
          <span class="gray" v-if="scope.row.status === 'OFFLINE'">下架</span>
          <span
              class="danger"
              v-if="!scope.row.status && scope.row.status !== 0"
          >{{ scope.row.auditmsg }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="reason"
          label="驳回原因"
      >
        <template slot-scope="scope">
          <div v-html="scope.row.reason"></div>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          label="是否线上版本"
      >
        <template slot-scope="scope">
          <span
              v-if="
              scope.row.miniProgramVersion === scope.row.releaseVersion && scope.row.miniProgramVersion
            "
              class="success"
          >是</span
          >
          <span
              v-if="scope.row.miniProgramVersion !== scope.row.releaseVersion"
              class="danger"
          >否</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="center" width="650">
        <template slot-scope="scope">
          <el-button type="text" size="small" class="blue" @click="IsvUpload(scope.row)"
          >上传版本</el-button
          >
          <el-button type="text" size="small" class="blue" @click="createExperienceAlipayTemp(scope.row)"
          >创建体验版</el-button
          >
          <el-button
              v-if="scope.row.pagecode !== '-1'"
              type="text"
              size="small"
              class="blue"
              @click="creatQrcode(scope.row)"
          >体验版二维码</el-button
          >
          <el-button type="text" size="small" class="blue" @click="openDialog(scope.row)"
          >提交审核</el-button
          >
          <el-button
              type="text"
              size="small"
              class="blue"
              @click="versionFallback(scope.row)"
          >撤销审核</el-button
          >
          <el-button
              type="text"
              size="small"
              class="blue"
              @click="onlineAlipayTemp(scope.row)"
          >发布线上</el-button
          >
          <el-button type="text" size="small" class="blue" @click="openDeveloper(scope.row)"
          >添加开发者/体验者</el-button
          >
          <el-button type="text" size="small" class="blue" @click="createQrcodeAlipayTemp(scope.row)" v-if="false"
          >小程序路径码</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination mb20">
      <el-pagination
          background
          :total="uploadedAlipayTempListTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
        title="创建支付宝小程序"
        :close-on-click-modal="false"
        @close="dialogVisibleCreate = false"
        :visible.sync="dialogVisibleCreate"
    >
      <div class="text-left">
        <el-form
        :model="ruleFormCreate"
        ref="ruleFormCreate"
        label-width="200px"
        >
        <el-form-item label="商户列表" prop="storeCode">
          <el-select
            size="small"
            clearable
            class="mr10"
            :disabled="!storeBasicList.length"
            placeholder="请选择商户"
            v-model="ruleFormCreate.storeCode"
            filterable
          >
            <el-option
              :label="item.storeName"
              :value="item.storeCode"
              v-for="(item, i) in storeBasicList"
              :key="i"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业支付宝账号" prop="alipayAccount">
          <el-input
            clearable
            maxlength="50"
            @mousewheel.prevent.native
            v-model.trim="ruleFormCreate.alipayAccount"
            placeholder="请输入商家登录支付宝的邮箱账号或者手机号"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        <el-form-item label="商家法人名称" prop="legalPersonalName">
          <el-input
            clearable
            maxlength="50"
            @mousewheel.prevent.native
            v-model.trim="ruleFormCreate.legalPersonalName"
            placeholder="请输入商家法人名称"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        <el-form-item label="营业执照企业名称" prop="certName">
          <el-input
            clearable
            @mousewheel.prevent.native
            v-model.trim="ruleFormCreate.certName"
            placeholder="请输入营业执照企业名称"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        <el-form-item label="营业执照编码" prop="certNo">
          <el-input
            clearable
            @mousewheel.prevent.native
            v-model.trim="ruleFormCreate.certNo"
            placeholder="请输入营业执照编码"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        <el-form-item label="小程序名称" prop="appName">
          <el-input
            clearable
            @mousewheel.prevent.native
            v-model.trim="ruleFormCreate.appName"
            placeholder="请输入小程序名称"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        <el-form-item label="商家联系人手机号" prop="contactPhone">
          <el-input
            clearable
            @mousewheel.prevent.native
            v-model.trim="ruleFormCreate.contactPhone"
            placeholder="请输入商家联系人手机号"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        <el-form-item label="商家联系人名称" prop="contactName">
          <el-input
            clearable
            @mousewheel.prevent.native
            v-model.trim="ruleFormCreate.contactName"
            placeholder="请输入商家联系人名称"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitForm('ruleFormCreate')" size="small" type="primary"
          >确 认</el-button
        >
        <el-button @click="dialogVisibleCreate = false" size="small">取 消</el-button>
      </span>
      </div>
    </el-dialog>
    <el-dialog
        title="添加开发者/体验者"
        :close-on-click-modal="false"
        @close="dialogVisibleDeveloper = false"
        :visible.sync="dialogVisibleDeveloper"
    >
      <div class="text-center">
        <div class="flex flex-between mb10">
          <div class="flex flex-start">
            <el-radio-group
                class="mb10"
                size="small"
                v-model="memberType"
                @change="switchIsMember"
            >
              <el-radio-button label="DEVELOPER">开发者</el-radio-button>
              <el-radio-button label="EXPERIENCER">体验者</el-radio-button>
            </el-radio-group>
          </div>
          <div class="flex flex-end">
            <el-button type="primary" size="small" @click="openAddDeveloper">添加成员</el-button>
          </div>
          <!-- <div class="flex flex-end">
          <el-select
            size="small"
            clearable
            placeholder="请选择成员身份"
            v-model="searchCondition.role"
            class="mr10"
            filterable
          >
            <el-option label="开发者" value="DEVELOPER"></el-option>
            <el-option label="体验者" value="EXPERIENCER"></el-option>
          </el-select>
          <el-input
            style="width:280px"
            clearable
            v-model.trim="searchCondition.phone"
            placeholder="请输入成员账号"
            size="small"
            class="ipt mr10"
          >
          </el-input>
          <el-button type="primary" size="small" @click="search">查询</el-button>
          </div> -->
        </div>
        
        <el-table
          stripe
          ref="tableData"
          :data="tableData"
          style="width: 100%"
          id="table"
          size="small"
          border
          >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="role"
            label="角色">
              <template slot-scope="scope">
                <span v-if="scope.row.role === 'DEVELOPER'">开发者</span>
                <span v-if="scope.row.role === 'EXPERIENCER'">体验者</span>
              </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="memberShip"
            label="登录号">
              <template slot-scope="scope">
                <div class="develop-member-username">
                  <el-image
                    class="mr10 memberImage"
                    :src="alipayImageSrc+scope.row.portrait"
                  ></el-image>
                  <span>{{scope.row.logonId}}</span>
                </div>
              </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="nickName"
            label="昵称">
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="gmtJoin"
            label="添加时间">
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="status"
            label="状态">
              <template slot-scope="scope">
                <span class="success" v-if="scope.row.status === 'VALID'">已加入</span>
                <span class="orange" v-if="scope.row.status === 'UNCONFIRMED'">未确认</span>
                <span class="gray" v-if="scope.row.status === 'TIMEOUT'">邀请失效</span>
                <span class="danger" v-if="scope.row.status === 'REFUSED'">用户拒绝</span>
              </template>
          </el-table-column>
          <el-table-column label="操作"
           header-align="center"
           align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" class="danger" @click="deleteMembers(scope.row)"
              >删除</el-button>
            </template>
        </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button @click="dialogVisibleDeveloper = false" size="small" type="primary"
          >关 闭</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
        title="添加成员"
        :close-on-click-modal="false"
        :visible.sync="dialogVisibleAddDeveloper"
    >
      <div class="text-left">
        <el-form
        label-width="200px"
        >
        <el-form-item label="成员身份">
          <el-select
            size="small"
            clearable
            placeholder="请选择成员身份"
            v-model="AddRole"
            class="mr10"
            filterable
          >                              
            <el-option label="开发者" value="DEVELOPER"></el-option>
            <el-option label="体验者" value="EXPERIENCER"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付宝账号">
          <el-input
            clearable
            @mousewheel.prevent.native
            v-model="AddLogonId"
            placeholder="请输入要添加的支付宝账号"
            size="small"
            class="ipt mr10"
          ></el-input>
        </el-form-item>
        </el-form>
          <span slot="footer" class="dialog-footer flex flex-center mt20">
          <el-button @click="createMembers" size="small" type="primary"
            >添 加</el-button>
          <el-button @click="createMembersCancel" size="small">取 消</el-button>
          </span>
      </div>
    </el-dialog>
    <el-dialog
        title="体验版二维码"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
    >
      <div class="text-center">
        <div>{{ currentRow.name }}</div>
        <div>{{ currentRow.version }}</div>
        <img :src="qrcode" alt="体验版二维码" />
      </div>
    </el-dialog>
    <el-dialog
        title="提交审核"
        :close-on-click-modal="false"
        :visible.sync="checkDialogVisible"
    >
      <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
      >
        <el-form-item label="小程序描述:">
          <el-input              
              maxlength="200"
              type="textarea"
              v-model="ruleForm.feedbackInfo"
              placeholder="必填，若有其他描述请在备注标明"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="flex flex-center">
            <el-button type="primary" size="small" @click="save('ruleForm')"
            >保存</el-button
            >
            <el-button size="small" @click="checkDialogVisible = false"
            >取消</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      filterText: "",
      mpType: "0",
      miniProgramType: "1",
      isLive: "1",
      currentPage: 1,
      pageSize: 10,
      uploadedAlipayTempListTotal: 0,
      qrcode: "",
      currentRow: {},
      dialogVisible: false,
      uploadedAlipayTempList: [],
      uploadedAlipayTempListResult: [],
      currentPageList: [],
      category: {},
      ruleForm: {
        feedbackInfo: "",
        address: ""
      },
      ruleFormCreate:{
      },
      searchCondition:{},
      dialogVisibleCreate:false,
      dialogVisibleDeveloper:false,
      dialogVisibleAddDeveloper:false,
      AddDeveloperAccount:"",
      AddExperiencerAccount:"",
      rules: {
        address: {
          required: true,
          message: "请选择页面",
          trigger: "change"
        }
      },
      checkDialogVisible: false,
      currentAppId: "",
      checkedRows: [],
      tableData: [],
      authorizerAppid:"",
      logonId:"",
      role:"DEVELOPER",
      userId:"",
      ruleFormAddMembers:[],
      memberType:"DEVELOPER",
      alipayImageSrc:"https://tfsimg.alipay.com/images/partner/",
      AddRole:"",
      AddLogonId:"",
      storeBasicList:[],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryUploadedAlipayTemp();
  },
  mounted() {
    this.queryStoreBasicList();
  },
  methods: {
    async batchAudit() {
      if (this.checkedRows.length) {
        const params = Object.assign(this.checkedRows);
        console.log(params);
        const { code } = await this.$store.dispatch("mpBatchAudit", params);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.checkDialogVisible = false;
          this.queryUploadedAlipayTemp();
        }
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    async batchPublish() {
      if (this.checkedRows.length) {
        const params = Object.assign(this.checkedRows);
        console.log(params);
        const { code } = await this.$store.dispatch("batchPublish", params);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.checkDialogVisible = false;
          this.queryUploadedAlipayTemp();
        }
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    getChecked(selection) {
      this.checkedRows = selection;
      console.log(this.checkedRows);
    },
    async submitSetprivacysetting(row) {
      await this.$store.dispatch("setprivacysetting", {
        authorizerAppid: row.authorizerAppid
      });
      this.$message({
        message: "操作成功",
        type: "success"
      });
    },
    //打开提交审核页面
    openDialog(row) {
      console.log(row);
      this.checkDialogVisible = true;
      this.currentAppId = row.authorizerAppid;
      // this.currentPageList = row.pageList;
      // this.getMpCategory();
    },
    async save() {
        const params ={
          versionDesc: this.ruleForm.feedbackInfo,
          authorizerAppid: this.currentAppId
        };
        const { code } = await this.$store.dispatch("applyAlipayTemp", params);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.checkDialogVisible = false;
          this.ruleForm.feedbackInfo = "";
          this.queryUploadedAlipayTemp();
        }
    },
    // 查询支付宝列表
    async queryUploadedAlipayTemp() {
      const { result } = await this.$store.dispatch("queryUploadedAlipayTemp", {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      });
      console.log("result.result:",result.records);
      this.uploadedAlipayTempList = result.records;
      this.filterFunc("uploadedAlipayTempList");
      this.uploadedAlipayTempListTotal = result.total;
    },
    //筛选名字和版本号
    filterFunc(originData) {
      console.log("filterFunc",originData);
      this[originData + "Result"] = this[originData].filter(v => {
        return (
            v.nickName.indexOf(this.filterText) > -1 ||
            v.releaseVersion.indexOf(this.filterText) > -1 ||
            v.miniProgramVersion.indexOf(this.filterText) > -1
        );
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryUploadedAlipayTemp();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryUploadedAlipayTemp();
    },
    async creatQrcode(row) {
      const { result } = await this.$store.dispatch("queryExperienceAlipayTemp", {
        authorizerAppid: row.authorizerAppid
      });
      if (result) {
        this.currentRow = row;
        this.qrcode = result;
        this.dialogVisible = true;
      }else{
        this.$message({
            message: " 暂无体验码!",
            type: "warning"
        });
      }
    },
    async getMpCategory() {
      const { result } = await this.$store.dispatch("getMpCategory", {
        authorizerAppid: this.currentAppId
      });
      console.log("result: ", result);
      if (result) {
        this.category = result[0] || {};
      }
    },
    async cancle(row) {
      const result = await this.$confirm("是否撤回审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("cancelAudit", {
          authorizerAppid: row.authorizerAppid
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryUploadedAlipayTemp();
        }
      }
    },
    async expeditedReviewMp(row) {
      const result = await this.$confirm("是否提交加急审核申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("expeditedReviewMp", {
          authorizerAppid: row.authorizerAppid
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryUploadedAlipayTemp();
        }
      }
    },
    async versionFallback(row) {
      const result = await this.$confirm("是否撤销审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("cancelAlipayTemp", {
          authorizerAppid: row.authorizerAppid
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryUploadedAlipayTemp();
        }
      }
    },
    // 打开创建小程序页面
    openCreate(){
      this.dialogVisibleCreate = true;
    },
    // 打开添加开发者/体验者页面
    openDeveloper(row){
      this.dialogVisibleDeveloper = true;
      this.authorizerAppid = row.authorizerAppid;
      this.memberType = "DEVELOPER" ;
      this.switchIsMember("DEVELOPER");
    },
    // 查询开发者/体验者方法
    async queryMiniMembersRequest(){
      this.tableData = [];
      const { result } = await this.$store.dispatch("queryMiniMembersRequest", {
          authorizerAppid: this.authorizerAppid,
          logonId: this.logonId,
          role: this.role,
          userId: this.userId
      });
      if (result) {
        this.tableData = result
      }else{
        this.tableData = [];
      }
    },
    //添加成员方法
    async createMembers(){
      const { code } = await this.$store.dispatch("createMiniMembersRequest", {
          authorizerAppid: this.authorizerAppid,
          logonId: this.AddLogonId,
          role: this.AddRole
      });
      if(code === '0'){
        this.role = this.AddRole;
        this.memberType = this.role;
        this.AddRole = "";
        this.AddLogonId = "";
        this.dialogVisibleAddDeveloper = false;
        this.queryMiniMembersRequest();
      }
    },
    //删除成员方法
    async deleteMembers(row){
      const result = await this.$confirm("是否删除该成员("+row.nickName+")?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("deleteMiniMembersRequest", {
            authorizerAppid: this.authorizerAppid,
            logonId: row.logonId,
            role: row.role,
            userId: row.userId
        });
        if(code === '0'){
          this.queryMiniMembersRequest();
        }
      }
    },
    //添加成员页面取消按钮点击
    createMembersCancel(){
      this.dialogVisibleAddDeveloper = false;
      this.AddLogonId = "";
      this.AddRole = "";
    },
    //开发者和体验者按钮切换
    switchIsMember(e){
      this.role = e;
      this.queryMiniMembersRequest();
    },
    // 打开添加成员页面
    openAddDeveloper(){
      this.AddRole = this.role;
      this.dialogVisibleAddDeveloper = true;
    },
    //创建小程序页面确认按钮点击
    async submitForm() {
      console.log("保存");
      console.log("this.ruleFormCreate:",this.ruleFormCreate);
      const { code } = await this.$store.dispatch("createMiniRequest", {
        createMiniRequest:this.ruleFormCreate,
        storeCode:this.ruleFormCreate.storeCode
      });
      if( code === '0'){
        this.dialogVisibleCreate = false;
        this.queryUploadedAlipayTemp();
      }
    },
    search(){
      console.log("搜索");
    },
    async queryStoreBasicList() {
      const { result } = await this.$store.dispatch(
        "queryStoreBasicListComboBox"
      );
      if(result){
        this.storeBasicList = result || [];
        console.log("this.storeBasicList:",this.storeBasicList);
      }
    },
    async IsvUpload(row){
      const result = await this.$confirm("是否上传版本?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("queryIsvUploadedAlipayTemp", {
            authorizerAppid: row.authorizerAppid,
        });
        if(code === '0'){
          this.queryUploadedAlipayTemp();
        }
      }
    },
    async createExperienceAlipayTemp(row){
      const result = await this.$confirm("是否创建体验版?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("createExperienceAlipayTemp", {
            authorizerAppid: row.authorizerAppid,
        });
        if(code === '0'){
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryUploadedAlipayTemp();
        }
      }
    },
    async createQrcodeAlipayTemp(row){
      const result = await this.$confirm("是否创建小程序路径码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("createQrcodeAlipayTemp", {
            authorizerAppid: row.authorizerAppid,
        });
        if(code === '0'){
          console.log("code:",code); 
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryUploadedAlipayTemp();         
        }
      }      
    },
    async onlineAlipayTemp(row){
      const result = await this.$confirm("是否发布上线?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("onlineAlipayTemp", {
            authorizerAppid: row.authorizerAppid,
            versionDesc: row.releaseVersion
        });
        if(code === '0'){
          console.log("code:",code);  
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryUploadedAlipayTemp();        
        }
      }      
    },
  }
};
</script>
<style lang="scss" scoped>
.develop-member-username{
  display: flex;
  align-items: center;
}
.memberImage{
  width: 48px;
  height: 48px;
}
</style>
